import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import ImageViewer from 'react-simple-image-viewer';

import cn from 'classnames';

const ImagesViewer = ({ images = [], small = true, className, ...props }) => {
  const [imgs, setImgs] = useState([]);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = () => {
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
  };

  useEffect(() => {
    setImgs(images);
  }, [images]);
  return (
    <>
      {small ? (
        <div className={small && styles.wrapper}>
          {imgs.length > 0 && (
            <img onClick={() => openImageViewer()} className={styles.preview} src={imgs[0]} alt="preview" {...props} />
          )}
        </div>
      ) : (
        <>
          {imgs.length > 0 && (
            <img
              onClick={() => openImageViewer()}
              className={cn(styles.preview_big, className)}
              src={imgs[0]}
              alt="preview"
              {...props}
            />
          )}
        </>
      )}
      {isViewerOpen && <ImageViewer src={imgs} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default ImagesViewer;
